import { FileUploadImportConfig } from '@oneschema/react';
import React, { useCallback } from 'react';

import { OneSchemaWrapper } from '../one-schema-wrapper';
import { GITHUB_EMAIL_MAPPING_TEMPLATE_KEY } from './github-email-mapping-upload.constants';
import { useAddGithubEmailMappingFile } from './hooks';

type GithubEmailMappingUploadModalProps = {
  close: () => void;
  companyId: string;
  isOpen: boolean;
};

export const GithubEmailMappingUploadModal = ({
  close,
  companyId,
  isOpen,
}: GithubEmailMappingUploadModalProps): React.ReactElement => {
  const { handleSuccess, oneSchemaJwt, permanentUrl, signedUrl } = useAddGithubEmailMappingFile({ companyId, isOpen });

  const onSuccess = useCallback(async (): Promise<void> => {
    await handleSuccess();
    close();
  }, [close, handleSuccess]);

  const importConfig: FileUploadImportConfig = {
    format: 'csv',
    type: 'file-upload',
    url: signedUrl ?? '',
  };

  return (
    <OneSchemaWrapper
      isOpen={isOpen && !!oneSchemaJwt && !!signedUrl && !!permanentUrl}
      userJwt={oneSchemaJwt ?? ''}
      templateKey={GITHUB_EMAIL_MAPPING_TEMPLATE_KEY}
      importConfig={importConfig}
      onCancel={close}
      onError={close}
      onSuccess={onSuccess}
    />
  );
};
